import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { WorksheetEntitySummaryIndex } from 'services/worksheet/types';
import { selectSprayWorksheetEntitySummaries } from '../../../../selectors';
import { OwnProps } from './index';

const selectEntitySummaryIndex = (
    state: AppState,
    props: OwnProps
): WorksheetEntitySummaryIndex => props.entitySummaryIndex;

const selectHectares = createDeepEqualSelector(
    selectSprayWorksheetEntitySummaries,
    selectEntitySummaryIndex,
    (entitySummaries, index) => get(entitySummaries, [index, 'sumTotalArea'])
);

const makeSelectHectares = (): typeof selectHectares => selectHectares;

export { selectEntitySummaryIndex, makeSelectHectares };
